module.exports = __webpack_public_path__ + "static/2-93db9411017ef3105a2929831eb15d57.jpg";